

  <div class="flex flex-col flex-auto min-w-0">
        <!-- Header -->
        <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
            <div class="flex-1 min-w-0">
                <!-- Breadcrumbs -->
                <div class="flex flex-wrap items-center font-medium">
                    <div>
                        <a class="whitespace-nowrap text-primary-500">Portfolios</a>
                    </div>
                </div>
                <!-- Title -->
                <div class="mt-2">
                    <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                        Find the right portfolio and get a free quote.
                    </h2>
                </div>
            </div>
        </div>

        
    <div class="flex-auto p-6 sm:p-10">


         <div class="mb-6 sm:mb-12">

            <!-- Advanced search form -->
            <form
                class="flex flex-col items-start w-full p-8 space-y-8 rounded-2xl shadow overflow-hidden bg-card"
                [formGroup]="searchForm">

                <!-- Keywords -->
                <!-- <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Keywords</mat-label>
                    <input
                        [autocomplete]="'off'"
                        [formControlName]="'keywords'"
                        matInput>
                </mat-form-field> -->

                <!-- Type -->
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Skills</mat-label>
                    <mat-select [formControl]="selectSkills"  (openedChange)="searchSkills($event)"   multiple>
                        <!-- <mat-option [value]="'any'">All</mat-option> -->
                        <mat-option #allSelected (click)="toggleAllSelection()" [value]="0">All</mat-option>
                        <mat-option *ngFor="let skill of skills" [value]="skill.id">{{ skill.name }}</mat-option>
                                                <!-- <mat-option [value]="'any'">Any</mat-option>
                        <mat-option [value]="'files'">Files</mat-option>
                        <mat-option [value]="'folders'">Folders</mat-option> -->
                    </mat-select>
                </mat-form-field>

                <!-- <mat-form-field>
                    <mat-select placeholder="Skills" [formControl]="toppings" [(value)]="selectedToppings" multiple>
                      <mat-option *ngFor="let topping of toppingList" [value]="topping">{{topping}}</mat-option>
                    </mat-select>
                  </mat-form-field> -->

                <!-- Actions -->
                <!-- <div class="flex items-center justify-end w-full mt-8">
                    <button
                        class="ml-2"
                        (click)="search()"
                        [color]="'primary'"
                        type="button"
                        mat-flat-button>Search
                    </button>
                </div> -->
            </form>
            <!-- <mat-button-toggle-group
                class="flex flex-wrap -m-2"
                [(ngModel)]="selectedFilter"
                (change)="onFilterChange($event)">
                <ng-container *ngFor="let skill of skills">
                    <mat-button-toggle
                        class="m-2"
                        [value]="skill.id">
                        <span class="text-secondary">{{skill.name | titlecase}}</span>
                        <span class="ml-1.5 font-medium text-secondary">({{numberOfCards[skill.id]}})</span>
                    </mat-button-toggle>
                </ng-container>
            </mat-button-toggle-group> -->
        </div> 

        <div class="flex flex-wrap items-start w-full max-w-400 -m-4">
            <fuse-card *ngFor="let hirePortfolio of portfolios"
            class="flex flex-col max-w-80 w-full {{ addFilters(hirePortfolio) }}" #expandableCard02="fuseCard">

    
            <!-- IF one image -->
            <div class="relative mb-4">
                <!-- <swiper
                [config]="config"
                (swiper)="onSwiper($event)"
                (slideChange)="onSlideChange()"
              >
                <ng-template swiperSlide>
                    <img 
                    class="h-80 object-cover"
                    src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                    alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                </ng-template>
                <ng-template swiperSlide>Slide 2</ng-template>
                <ng-template swiperSlide>Slide 3</ng-template>
                <ng-template swiperSlide>Slide 4</ng-template>
                <ng-template swiperSlide>Slide 5</ng-template>
                <ng-template swiperSlide>Slide 6</ng-template>
              </swiper> -->
                
              <swiper [pagination]="true" class="mySwiper">
                <ng-template *ngFor="let hirePortfolioImg of hirePortfolio.hirePortfolioImgs" swiperSlide> <img 
                    class="h-80 object-cover"
                    src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolioImg.id + '/' + hirePortfolioImg.name + '_3x.' + hirePortfolioImg.ext }}"
                    alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)"></ng-template>
              </swiper>
            </div>
    
            <!-- IF two image -->
            <!-- <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 2" class="flex mx-6 sm:mx-8 mb-4">
                <div class="flex h-80 pr-1"
                    *ngFor="let hirePortfolioImg of hirePortfolio.hirePortfolioImgs; let i = index">
                    <img class="rounded object-cover"
                        src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolioImg.id + '/' + hirePortfolioImg.name + '_3x.' + hirePortfolioImg.ext }}"
                        alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, i)">
                </div>
            </div> -->
    
            <!-- IF three image -->
            <!-- <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 3" class="flex mx-6 sm:mx-8 mb-4">
                <div class="flex h-80 pr-1">
                    <img class="rounded object-cover"
                        src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                        alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                </div>
                <div class="flex flex-col pl-1">
                    <div class="flex h-40 pb-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                    </div>
                    <div class="flex h-40 pt-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                    </div>
                </div>
            </div> -->
    
            <!-- IF four image -->
            <!-- <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 4" class="flex mx-6 sm:mx-8 mb-4">
                <div class="flex flex-col pr-1">
                    <div class="flex h-40 pb-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                    </div>
                    <div class="flex h-40 pt-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                    </div>
                </div>
                <div class="flex flex-col pl-1">
                    <div class="flex h-40 pb-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                    </div>
                    <div class="flex h-40 pt-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[3].id + '/' + hirePortfolio.hirePortfolioImgs[3].name + '_3x.' + hirePortfolio.hirePortfolioImgs[3].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 3)">
                    </div>
                </div>
            </div> -->
    
            <!-- IF five image -->
            <!-- <div *ngIf="hirePortfolio.hirePortfolioImgs.length == 5" class="flex flex-col mx-6 sm:mx-8 mb-4">
                <div class="flex pb-1">
                    <div class="flex h-60 pr-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                    </div>
                    <div class="flex h-60 pl-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                    </div>
                </div>
                <div class="flex pt-1">
                    <div class="flex h-40 pr-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                    </div>
                    <div class="flex h-40 px-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[3].id + '/' + hirePortfolio.hirePortfolioImgs[3].name + '_3x.' + hirePortfolio.hirePortfolioImgs[3].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 3)">
                    </div>
                    <div class="flex h-40 pl-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[4].id + '/' + hirePortfolio.hirePortfolioImgs[4].name + '_3x.' + hirePortfolio.hirePortfolioImgs[4].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 4)">
                    </div>
                </div>
            </div> -->
    
            <!-- IF five and more image -->
            <!-- <div *ngIf="hirePortfolio.hirePortfolioImgs.length > 5" class="flex flex-col mx-6 sm:mx-8 mb-4">
                <div class="flex pb-1">
                    <div class="flex h-60 pr-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[0].id + '/' + hirePortfolio.hirePortfolioImgs[0].name + '_3x.' + hirePortfolio.hirePortfolioImgs[0].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 0)">
                    </div>
                    <div class="flex h-60 pl-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[1].id + '/' + hirePortfolio.hirePortfolioImgs[1].name + '_3x.' + hirePortfolio.hirePortfolioImgs[1].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 1)">
                    </div>
                </div>
                <div class="flex pt-1">
                    <div class="flex h-40 pr-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[2].id + '/' + hirePortfolio.hirePortfolioImgs[2].name + '_3x.' + hirePortfolio.hirePortfolioImgs[2].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 2)">
                    </div>
                    <div class="flex h-40 px-1">
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[3].id + '/' + hirePortfolio.hirePortfolioImgs[3].name + '_3x.' + hirePortfolio.hirePortfolioImgs[3].ext }}"
                            alt="Card cover image" (click)="viewPortfolioImgs(hirePortfolio, 3)">
                    </div>
                    <div class="relative flex h-40 pl-1">
                        <div class="absolute flex items-center justify-center inset-0 ml-1 rounded overflow-hidden">
                            <span class="z-10 text-4xl text-white">+{{ hirePortfolio.hirePortfolioImgs.length
                                }}</span>
                            <span class="absolute w-full h-full bg-primary opacity-70"></span>
                        </div>
                        <img class="rounded object-cover"
                            src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/portfolios/' + hirePortfolio.id + '/' + hirePortfolio.hirePortfolioImgs[4].id + '/' + hirePortfolio.hirePortfolioImgs[4].name + '_3x.' + hirePortfolio.hirePortfolioImgs[4].ext }}"
                            alt="Card cover image">
                    </div>
                </div>

            </div> -->


            <div class="flex items-center mx-6 sm:mx-8 mt-6 mb-4" [routerLink]="['/s', hirePortfolio.hireProfile.store.online_id]" >
                <img *ngIf="hirePortfolio.hireProfile.profile_img_name" class="w-10 h-10 rounded-full mr-4"
                src="{{ 'https://storage.googleapis.com/eseel_publicend_inventory/' + hirePortfolio.hireProfile.store.online_id + '/profile/' + hirePortfolio.hireProfile.profile_img_name  }}"
                alt="Card cover image">
                <img *ngIf="!hirePortfolio.hireProfile.profile_img_name" class="w-10 h-10 rounded-full mr-4"
                src="assets/images/logo/eseel_logo_hire_user.png" alt="Card cover image">
                <div class="flex flex-col">
                    <span class="font-semibold leading-none">{{ hirePortfolio.hireProfile.title }}</span>
                    <span class="text-sm text-secondary leading-none mt-1"> Store ID {{ hirePortfolio.hireProfile.store.online_id }}</span>
                </div>
            </div>


            <!-- <div class="m-8">                
                <div class="flex items-center mt-6">
                    <img
                        class="w-10 h-10 rounded-full"
                        src="assets/images/cards/avatar-400x400.jpg"
                        alt="Card cover image">
                    <div class="flex flex-col ml-3">
                        <span class="font-medium leading-none">Galen Lewis</span>
                        <span class="text-sm text-secondary leading-none mt-1">23 hours ago</span>
                    </div>
                </div>
            </div> -->
            <div class="m-8 mb-0">
                <!-- <div class="flex flex-col">
                    <div class="text-2xl leading-tight">Black sneakers with white stripes</div>
                    <div class="text-3xl font-semibold mt-2">$240.00</div>
                </div>
                <hr class="border-b my-6">
                <div class="flex items-center text-md">
                    <span class="text-secondary whitespace-nowrap mr-3">Select a size:</span>
                    <span class="mr-2">39</span>
                    <span class="mr-2">40</span>
                    <span class="mr-2">41</span>
                    <span class="font-bold text-primary mr-2">42</span>
                    <span class="mr-2">43</span>
                </div> -->
                <div class="mt-6 -mx-8">
                    <button
                        class="w-full rounded-t-none"
                        mat-flat-button
                        [color]="'primary'"
                        [routerLink]="['/q', hirePortfolio.hireProfile.store.online_id]"
                        style="border-radius: 0px !important;">
                        Get A Quotation
                    </button>
                </div>
            </div>
        </fuse-card>


        </div>

        
    </div>


  </div>
  

    
            
        

        


